import "../App.css";
function Home() {
  return (
    <div className="home">
      <div className="logo">
        <h1 className="introHead">Mexican Food Catering Service </h1>
        <img src="../images/logotaco.png" alt="logo" />
      </div>

      {/* <div className="secondDiv ">
        <h1>Welcome to Yummy Tacos!!</h1>
        <button className="welcomeButton">Book Right now</button>
      </div> */}
    </div>
  );
}

export default Home;
